import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService, TokenService } from '@core/services';

/**
 * Authenticated Guard
 * Redirects authenticated users away from public routes (like login)
 * Use this on login/register pages to prevent logged-in users from accessing them
 *
 * @example
 * const routes: Routes = [
 *   {
 *     path: 'login',
 *     component: LoginComponent,
 *     canActivate: [authenticatedGuard]
 *   }
 * ];
 */
export const authenticatedGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const tokenService = inject(TokenService);
  const router = inject(Router);

  // Check if refresh token is expired
  const refreshExpired = await tokenService.isRefreshTokenExpired$();
  if (refreshExpired) {
    authService.clear();
    tokenService.clearToken();
    return true; // Allow access to login page
  }

  // Get user
  const user = await authService.user;
  if (!user) {
    authService.clear();
    tokenService.clearToken();
    return true; // Allow access to login page
  }

  // User is authenticated, redirect to menu
  return router.createUrlTree(['/menu']);
};
